var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path5, _path6, _path7, _circle12, _circle13, _circle14, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteLabelLargeColored = function SvgWhiteLabelLargeColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 498,
    height: 566,
    fill: "none",
    viewBox: "0 0 498 566"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#white-label-large-colored_svg__a)",
    strokeWidth: 2,
    d: "M249 145v345"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#white-label-large-colored_svg__b)",
    strokeWidth: 2,
    d: "M322.244 176.171 175.166 323.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#white-label-large-colored_svg__c)",
    strokeWidth: 2,
    d: "M351.995 250.005h-208"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#white-label-large-colored_svg__d)",
    strokeWidth: 2,
    d: "M320.824 323.25 173.746 176.171"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 249,
    r: 130,
    stroke: "url(#white-label-large-colored_svg__e)",
    strokeDasharray: "4 4",
    strokeWidth: 2,
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 249,
    r: 248,
    stroke: "url(#white-label-large-colored_svg__f)",
    strokeDasharray: "4 4",
    strokeWidth: 2,
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 118,
    r: 27,
    fill: "#17161B",
    stroke: "url(#white-label-large-colored_svg__g)",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.369,
    cy: 156.369,
    r: 27,
    fill: "#17161B",
    stroke: "url(#white-label-large-colored_svg__h)",
    strokeWidth: 2,
    transform: "rotate(-45 156.369 156.369)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.631,
    cy: 341.631,
    r: 27,
    fill: "#17161B",
    stroke: "url(#white-label-large-colored_svg__i)",
    strokeWidth: 2,
    transform: "rotate(-45 341.631 341.631)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 249,
    r: 27,
    fill: "#17161B",
    stroke: "url(#white-label-large-colored_svg__j)",
    strokeWidth: 2,
    transform: "rotate(90 380 249)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 249,
    r: 27,
    fill: "#17161B",
    stroke: "url(#white-label-large-colored_svg__k)",
    strokeWidth: 2,
    transform: "rotate(90 118 249)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.631,
    cy: 156.369,
    r: 27,
    fill: "#17161B",
    stroke: "url(#white-label-large-colored_svg__l)",
    strokeWidth: 2,
    transform: "rotate(45 341.631 156.369)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.369,
    cy: 341.631,
    r: 27,
    fill: "#17161B",
    stroke: "url(#white-label-large-colored_svg__m)",
    strokeWidth: 2,
    transform: "rotate(45 156.369 341.631)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 249,
    r: 52,
    fill: "#17161B"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 249,
    r: 51,
    stroke: "url(#white-label-large-colored_svg__n)",
    strokeOpacity: 0.85,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m246.986 225.426-17.919 10.359a3.13 3.13 0 0 0-1.567 2.704v21.022c0 1.114.597 2.144 1.567 2.704l17.919 10.359c.985.57 2.204.568 3.188-.005l17.768-10.352a3.13 3.13 0 0 0 1.558-2.698v-21.037c0-1.11-.593-2.137-1.558-2.699l-17.768-10.352a3.18 3.18 0 0 0-3.188-.005m-.032 9.142-9.825 5.679a3.13 3.13 0 0 0-1.567 2.704v11.571c0 1.113.597 2.143 1.567 2.704l9.825 5.68a3.18 3.18 0 0 0 3.189-.006l9.737-5.673a3.12 3.12 0 0 0 1.557-2.698v-11.585a3.12 3.12 0 0 0-1.557-2.698l-9.737-5.673a3.18 3.18 0 0 0-3.189-.005",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M261.006 256.109a3.1 3.1 0 0 0 .431-1.58v-12.987l7.743-4.433a3.13 3.13 0 0 0-1.237-1.326l-17.769-10.352a3.18 3.18 0 0 0-3.188-.005l-17.919 10.359a3.14 3.14 0 0 0-1.245 1.326l7.741 4.432z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#38383A",
    fillRule: "evenodd",
    d: "M248.5 225.001a3.2 3.2 0 0 0-1.514.425l-17.919 10.359a3.14 3.14 0 0 0-1.245 1.326l7.741 4.432v12.979c0 .567.154 1.113.435 1.586l12.502-7.158z",
    clipRule: "evenodd"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 380,
    r: 27,
    fill: "#17161B",
    stroke: "url(#white-label-large-colored_svg__o)",
    strokeWidth: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 490,
    r: 52,
    fill: "#17161B"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 490,
    r: 51,
    stroke: "url(#white-label-large-colored_svg__p)",
    strokeOpacity: 0.85,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M254 378v-2a5 5 0 0 0-10 0v2m5 4.5v2m-3.2 4.5h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162v-1.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C254.72 378 253.88 378 252.2 378h-6.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311c-.327.642-.327 1.482-.327 3.162v1.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311c.642.327 1.482.327 3.162.327M107.687 252.645l1.908-1.101a.5.5 0 0 1 .342-.059l3.754.703a.5.5 0 0 0 .592-.494l-.014-3.29a.5.5 0 0 1 .068-.254l1.895-3.244a.5.5 0 0 0-.023-.539l-3.19-4.541M124 241.859c-5.5 2.641-2.5 6.141-1.5 6.641 1.877.938 4.488 1 4.488 1q.012-.249.012-.5c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10q.252 0 .5-.012m4.258-.048-3.167-8.349 8.349 3.167-3.702 1.48zM391 247.5l-.474-3.795c-.186-1.489-.28-2.233-.63-2.794a3 3 0 0 0-1.283-1.133c-.6-.278-1.35-.278-2.85-.278h-9.526c-1.5 0-2.25 0-2.85.278a3 3 0 0 0-1.283 1.133c-.35.561-.444 1.305-.63 2.794L371 247.5m3.5 4h13m-13 0a3.5 3.5 0 1 1 0-7h13a3.5 3.5 0 1 1 0 7m-13 0a3.5 3.5 0 1 0 0 7h13a3.5 3.5 0 1 0 0-7M375 248h.01m-.01 7h.01m5.99-7h6m-6 7h6M249 126h-6.8c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108v-9.6c0-1.12 0-1.68.218-2.108.192-.376.498-.682.874-.874.428-.218.988-.218 2.108-.218h.4c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216m0 9.6v-9.6m0 9.6h6.8c1.12 0 1.68 0 2.108-.218.376-.192.682-.498.874-.874.218-.428.218-.988.218-2.108v-9.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218h-.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216m93 30.1v19m8-9.5c0 4.908-5.354 8.478-7.302 9.615-.221.129-.332.193-.488.227a1.1 1.1 0 0 1-.42 0c-.156-.034-.267-.098-.488-.227-1.948-1.137-7.302-4.707-7.302-9.615v-4.783c0-.799 0-1.199.131-1.542.115-.304.303-.575.547-.79.275-.243.65-.383 1.398-.664l5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 0 1 .286 0c.107.016.211.055.419.133l5.362 2.01c.748.281 1.123.421 1.398.664.244.215.432.486.547.79.131.343.131.743.131 1.542zm-3 191 5-5-5-5m-10 0-5 5 5 5m7-14-4 18M157 158l-3-3m5.01-7.5V146m3.94 3.061 1.06-1.061m-1.06 9 1.06 1.061m-9-9L153.95 148m10.56 5h1.5m-15.879 11.869 9.237-9.238c.396-.396.595-.594.669-.822a1 1 0 0 0 0-.618c-.074-.228-.273-.426-.669-.822l-.737-.738c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.427.272-.823.668l-9.237 9.238c-.396.396-.594.594-.668.822a1 1 0 0 0 0 .618c.074.228.272.426.668.822l.737.738c.396.396.595.594.823.668.201.065.417.065.618 0 .228-.074.426-.272.822-.668M165 335c0 1.657-4.029 3-9 3s-9-1.343-9-3m18 0c0-1.657-4.029-3-9-3s-9 1.343-9 3m18 0v14c0 1.66-4 3-9 3s-9-1.34-9-3v-14m18 4.72c0 1.66-4 3-9 3s-9-1.34-9-3m18 4.72c0 1.66-4 3-9 3s-9-1.34-9-3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m243.79 504.742 1.169 2.629a4.42 4.42 0 0 0 4.044 2.629 4.42 4.42 0 0 0 4.045-2.629l1.169-2.629a4.85 4.85 0 0 1 4.94-2.846l2.86.304a4.43 4.43 0 0 0 4.298-2.189 4.42 4.42 0 0 0-.254-4.815l-1.693-2.327a4.86 4.86 0 0 1-.92-2.869 4.86 4.86 0 0 1 .929-2.858l1.693-2.326a4.42 4.42 0 0 0 .253-4.816 4.42 4.42 0 0 0-4.297-2.189l-2.86.305a4.87 4.87 0 0 1-2.94-.625 4.85 4.85 0 0 1-2-2.233l-1.178-2.629a4.42 4.42 0 0 0-4.045-2.629 4.42 4.42 0 0 0-4.044 2.629l-1.169 2.629a4.85 4.85 0 0 1-2 2.233 4.87 4.87 0 0 1-2.94.625l-2.869-.305a4.43 4.43 0 0 0-4.298 2.189 4.43 4.43 0 0 0 .254 4.816l1.693 2.326a4.86 4.86 0 0 1 0 5.716l-1.693 2.326a4.422 4.422 0 0 0 1.571 6.547 4.44 4.44 0 0 0 2.473.458l2.86-.305a4.87 4.87 0 0 1 2.94.625 4.85 4.85 0 0 1 2.009 2.233"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M249 496a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__a",
    x1: 247.972,
    x2: 241.988,
    y1: 459.392,
    y2: 459.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__b",
    x1: 187.488,
    x2: 183.31,
    y1: 309.474,
    y2: 305.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__c",
    x1: 162.449,
    x2: 162.524,
    y1: 248.977,
    y2: 242.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__d",
    x1: 187.521,
    x2: 191.806,
    y1: 188.493,
    y2: 184.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__e",
    x1: 356.756,
    x2: -166.856,
    y1: 125.233,
    y2: 325.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__f",
    x1: 453.818,
    x2: -541.443,
    y1: 13.748,
    y2: 394.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__g",
    x1: 272.032,
    x2: 160.115,
    y1: 91.546,
    y2: 134.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__h",
    x1: 179.401,
    x2: 67.484,
    y1: 129.915,
    y2: 172.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__i",
    x1: 364.663,
    x2: 252.746,
    y1: 315.177,
    y2: 358.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__j",
    x1: 403.032,
    x2: 291.115,
    y1: 222.546,
    y2: 265.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__k",
    x1: 141.032,
    x2: 29.115,
    y1: 222.546,
    y2: 265.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__l",
    x1: 364.663,
    x2: 252.746,
    y1: 129.915,
    y2: 172.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__m",
    x1: 179.401,
    x2: 67.484,
    y1: 315.177,
    y2: 358.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__n",
    x1: 290.773,
    x2: 82.928,
    y1: 199.871,
    y2: 279.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__o",
    x1: 272.032,
    x2: 160.115,
    y1: 353.546,
    y2: 396.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label-large-colored_svg__p",
    x1: 291.773,
    x2: 83.928,
    y1: 440.871,
    y2: 520.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgWhiteLabelLargeColored;